import React from 'react';

import Checkbox from '@amzn/meridian/checkbox';
import Input from '@amzn/meridian/input';
import Row from '@amzn/meridian/row';
import Text from '@amzn/meridian/text';
import { type ErrorRecord, type HandleChange } from 'src/hooks/useForm';
import { type Modification } from 'src/services/modification/types';

interface SiteFormFieldsProps {
  formData: Modification;
  errors: ErrorRecord<Modification>;
  handleChange: HandleChange<Modification>;
}

const JobModificationFormFields = ({ formData, errors, handleChange }: SiteFormFieldsProps) => {
  return (
    <div>
      <Row widths="fill" spacingInset={'400 none'}>
        <Text>Name</Text>
        <Input
          type="text"
          placeholder="Enter name..."
          aria-label="Name"
          value={formData.name}
          onChange={(v) => handleChange({ name: v })}
          error={errors.name?.error}
          errorMessage={errors.name?.errorMessage}
        />
      </Row>
      <Row widths="fill" spacingInset={'400 none'}>
        <Text>Description</Text>
        <Input
          type="text"
          placeholder="Enter description..."
          aria-label="Description"
          value={formData.description}
          onChange={(v) => handleChange({ description: v })}
          error={errors.description?.error}
          errorMessage={errors.description?.errorMessage}
        />
      </Row>
      <Row widths="fill" spacingInset={'400 none'}>
        <Text>Allow free form text</Text>
        <Checkbox
          checked={formData.isFreeFormTextAllowed}
          onChange={(v) => handleChange({ isFreeFormTextAllowed: v })}
        />
      </Row>
    </div>
  );
};

export default JobModificationFormFields;
